// src/hooks/useColor.ts - Fixed version that handles hex colors
import { useMemo } from 'react';
import { getItemByIdOrThrow } from 'src/utils';
import { useScene } from 'src/hooks/useScene';
import { DEFAULT_COLOR } from 'src/config';

export const useColor = (colorId?: string) => {
  const { colors } = useScene();

  const color = useMemo(() => {
    // 🔧 FIX: Handle hex colors directly (they start with #)
    if (!colorId) {
      // No color provided, use first available or default
      if (colors && colors.length > 0) {
        return colors[0];
      }
      // Return default color object
      return DEFAULT_COLOR;
    }

    // 🔧 FIX: If it's a hex color (starts with #), return it directly
    if (colorId.startsWith('#')) {
      return {
        id: '__HEX__',
        value: colorId
      };
    }

    // Otherwise, try to find it in the colors array
    try {
      return getItemByIdOrThrow(colors, colorId).value;
    } catch (error) {
      console.warn(`Color not found: ${colorId}, using default`);
      return DEFAULT_COLOR;
    }
  }, [colorId, colors]);

  return color;
};